import { connect } from 'react-redux';
import Component from './StreamVoD';
import { VIDEO_ON_DEMAND } from '../../../../api/stream/CustomStreamEvent';
import { setHeaderTitle } from '../../../../actions/layout';
import {
  listStateFromCRUD,
  listDispatchFromCrud
} from '../../../../selectors/crud';
import { getCurrentClubId } from '../../../../selectors/club-settings';
import {
  // eslint-disable-next-line no-unused-vars
  STREAM_ROUTER_EDIT,
  STREAM_ROUTER_NEW,
  VOD_ROUTER_NEW,
  STREAM_ROUTER_PAST,
  STREAM_ROUTER_UPCOMMING,
  STREAM_ROUTER_VOD,
  VOD_ROUTER_EDIT
} from '../constants';
import { push } from 'react-router-redux/lib/actions';
import { vodAction } from '../../../../actions/vod';
export default connect(
  (state, { categoryId }) => ({
    ...listStateFromCRUD(state.vod),
    list: state.vod.list.sort((a, b) => state.vod.items[b].order_number - state.vod.items[a].order_number),
    filter: categoryId ? {
      streamType: VIDEO_ON_DEMAND,
      club_id: getCurrentClubId(state),
      categoryId
    } : {
      streamType: VIDEO_ON_DEMAND,
      club_id: getCurrentClubId(state)
    }
  }),
  dispatch => {
    return {
      updateHeaderTitle: title => dispatch(setHeaderTitle(title)),
      ...listDispatchFromCrud(dispatch, vodAction),
      edit: id => dispatch(push(VOD_ROUTER_EDIT.replace(':id', id))),
      goToUpcomming: () => dispatch(push(STREAM_ROUTER_UPCOMMING)),
      goToPast: () => dispatch(push(STREAM_ROUTER_PAST)),
      gotoVoD: () => dispatch(push(STREAM_ROUTER_VOD)),
      addStream: () => dispatch(push(STREAM_ROUTER_NEW)),
      addVoD: () => dispatch(push(VOD_ROUTER_NEW)),
      save: async (item, data) => await dispatch(vodAction.save(item, data))
    };
  },
)(Component);



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/StreamVoD/index.js